module.exports = __webpack_public_path__ + "static/media/Cornelia Scheitz.39171097.png";